<template>
  <el-dialog
      v-model="dialogVisible"
      :show-header="false"
      title="修改密码"
      width="400px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="false"
      class="school-table"
      :before-close="handleClose">
    <template #header>
      <div class="border-bottom  border-secondary-subtle py-2 fw-bold text-center mb-2 position-relative ">
        找回密码
      </div>
    </template>
    <!--      头部-->
    <div class="dialog-item1">

      <el-form autoComplete="off"
               hide-required-asterisk
               :model="form"
               size="large"
               label-width="auto"
               style="width: 100%"
               ref="ruleFormRef"  >
        <input type="password" style="opacity: 0;position: absolute;">
        <el-form-item label="手机号：" prop="Tel" :rules="[
    {required: true, message: '请输入手机号', trigger: ['change', 'blur']},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur']}
  ]">
          <el-input type="text" v-model="form.Tel" />
        </el-form-item>
        <!--          验证码的提示-->
        <el-space fill class="mb-2" v-show="showCountState===2 || showCountState===3">
          <el-alert type="info" show-icon :closable="false" >
            <p class="text-start mb-0 small">如果收不到短信验证码?</p>
            <p class="text-start mb-0 small">1. 请再重试一次；</p>
            <p class="text-start mb-0 small">2. 如果反复重试还是收不到验证码短信，请联系技术支持人员 13361361078，微信同号</p>
          </el-alert>
        </el-space>
        <el-form-item label="验证码：" prop="Code"
                      :rules="{required: true, message: '请输入验证码', trigger: ['change', 'blur']}">
          <div class="d-flex align-items-center justify-content-between w-100 " >
            <el-input v-model="form.Code" class="me-2"  autocomplete="one-time-code" inputmode="numeric"/>
            <el-button style="width: 100px" type="primary" plain @click="sentCode" :disabled="!form.Tel" v-if="showCountState===1">发送验证码</el-button>
            <el-button style="width: 100px" type="primary" plain disabled loading v-if="showCountState===2">正在发送</el-button>
            <el-button style="width: 100px" type="primary" plain disabled v-if="showCountState===3">{{count}} s</el-button>
          </div>
        </el-form-item>
        <el-form-item label="新密码：" prop="Password"  :rules="{required: true, message: '请输入密码', trigger: ['change', 'blur']}">
          <el-input type="search" v-model="form.Password"  autocomplete="new-password" onfocus="this.type='password';this.removeAttribute('readonly');" readonly/>
        </el-form-item>
        <el-form-item label="确认密码：" prop="PasswordConfirm"  :rules="{required: true, message: '请确认密码', trigger: ['change', 'blur']}">
          <el-input type="search" v-model="form.PasswordConfirm"  autocomplete="new-password" onfocus="this.type='password';this.removeAttribute('readonly');" readonly/>
        </el-form-item>
        <div class="text-secondary small px-2">提示：每一届大赛的账号在大赛结束后将进行清理，参加本届大赛需重新注册</div>
      </el-form>


    </div>
    <template #footer>
      <span class="dialog-footer d-flex align-items-center justify-content-center">
        <el-button type="primary" @click="save(ruleFormRef)" :loading = "loading">确定</el-button>
         <el-button @click="handleClose">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, onMounted, reactive, onUnmounted} from 'vue';
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)

import {ElMessage} from "element-plus";
import {changeTeamPassword, sendSmsCode} from "@/api/login";
import {validateForm} from "@/utils/formValidate";
const showCountState = ref(1) // 1可以发送验证码，2，号码正在验证中 3，已发送
let interval = null
const count = ref(0)
const ruleFormRef = ref()
const loading = ref(false)
const form = reactive({
  Tel:"",
  Code:null,
  Password:null,
  PasswordConfirm:null
})




const props = defineProps({
  item: {
    default: {},
  }
})
// 开始
onMounted(() => {

})
onUnmounted(()=>{
  interval && clearInterval(interval)
})
const sentCode =async ()=>{
  var phoneReg =/^1[3-9]\d{9}$/
  if(!phoneReg.test(form.Tel)){
   return ElMessage.warning("请填写正确的手机号")
  }
  showCountState.value = 2
  const cres = await sendSmsCode({tel:form.Tel,Mode:1})
  if(cres.err_code===0){ // 已经发送
    showCountState.value = 3
    ElMessage.success('验证码发送成功')
    startCount()
  }else{
    showCountState.value = 1
    return ElMessage.error(cres.err_msg || "获取验证码失败")
  }
}
const startCount = ()=>{
  count.value = 60
  interval = setInterval(()=>{
    count.value = count.value - 1
    if(count.value===0){
      clearInterval(interval)
      showCountState.value = 1
    }
  },1000)
}
const save = async () => {
  const isValid = await validateForm(ruleFormRef.value)
  if (!isValid) {
    return
  }
  loading.value = true
  const res = await changeTeamPassword(form)
  loading.value = false
  if (res.err_code === 0) {
    ElMessage.success("密码修改成功")
    emits("success", form)
  } else {
    ElMessage.warning(res.err_msg || "修改失败")
  }
}
const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}




</script>

<style scoped lang="scss">
.dialog-item1 {
  width: 100%;
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}

.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}



</style>
